import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Tarifas',
    href: '#tarifas'
  }, {
    name: 'Opiniones',
    href: '#opiniones'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black shadow-lg py-1' : 'bg-black py-3'}`} data-id="element-115">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="flex items-center justify-between" data-id="element-117">
          {/* Logo — larger and prominent */}
          <div className="flex-shrink-0" data-id="element-118">
            <a href="#" className="flex items-center" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/oQVq4BzMykAbXhkeiAseTq/kdlr_talleres.jpg" alt="KDLR Talleres S.L Logo" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-16' : 'h-24'}`} data-id="element-120" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-121">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-semibold text-white hover:text-blue-400 transition-colors" data-id="element-122">
                {link.name}
              </a>)}
          </nav>

          {/* CTA Button (Desktop) */}
          <div className="hidden md:flex" data-id="element-123">
            <a href="#contacto" className="inline-flex items-center justify-center rounded-md bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 transition-colors glow-blue" data-id="element-124">
              Reservar cita
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden" data-id="element-125">
            <button type="button" className="inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-white/10 hover:text-blue-400 focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-126">
              <span className="sr-only" data-id="element-127">Abrir menú principal</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-128" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-129" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden bg-black border-t border-gray-800 ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-130">
        <div className="space-y-1 px-4 pb-6 pt-2" data-id="element-131">
          {navLinks.map(link => <a key={link.name} href={link.href} className="block rounded-md px-3 py-3 text-base font-medium text-white hover:bg-white/10 hover:text-blue-400" onClick={() => setIsMobileMenuOpen(false)} data-id="element-132">
              {link.name}
            </a>)}
          <a href="#contacto" className="mt-4 block w-full rounded-md bg-blue-600 px-5 py-3 text-center text-base font-medium text-white shadow-sm hover:bg-blue-700" onClick={() => setIsMobileMenuOpen(false)} data-id="element-133">
            Reservar cita
          </a>
        </div>
      </div>
    </header>;
}